import { Box, Typography, TypographyProps } from "@mui/material";

const BlockItem = ({
    title,
    value,
    Component,
    titleVariant = "small",
}: {
    title: string;
    value?: React.ReactNode;
    Component?: React.ReactNode;
    titleVariant?: TypographyProps["variant"];
}) => {
    return (
        <Box className="flex flex-col gap-1">
            <Typography
                variant={titleVariant}
                sx={{
                    color: "textColors.666",
                }}
            >
                {title}
            </Typography>
            {Component ? (
                Component
            ) : (
                <Typography
                    variant="textSm"
                    sx={{
                        fontWeight: "500",
                        color: "textColors.333",
                    }}
                >
                    {value}
                </Typography>
            )}
        </Box>
    );
};

export default BlockItem;
